import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";

@Injectable()
export class InPurchasesService {
  constructor(private auth: AuthenticationService, private http: Http) { }
  //--------------Purchase-----------------//
  getPurchase(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Purchase",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPurchaseById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPurchaseByDate(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseByDate",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPurchaseByVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseByVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPurchaseByGRN(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseByGRN",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  savePurchase(Purchase_Master: any) {
    if (Purchase_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Purchase",
          Purchase_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Purchase",
          Purchase_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deletePurchase(Id: any) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Delete_Purchase" ,Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
  }
  checkRefno(filterD) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/CheckRef",
        filterD,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getCurrency(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Currency",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPurchaseHistory(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/PurchaseHistory",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPurchasestock(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/PurchaseHistoryStock",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_AddBillCharges() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_AddBillCharges",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Update_PurchaseStatus(body:any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_PurchaseStatus",body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Purchase-----------------//
  //--------------Supplier-----------------//
  getSupplier(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Supplier",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSupplierForItemMaster(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SupplierForItemMaster",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSupplierById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Supplier_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getOutstandings(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_outstandings",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveSupplier(Supplier: any) {
    if (Supplier.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Supplier",
          Supplier,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Supplier",
          Supplier,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  getSupplierCode() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_GenerateCode",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getLedgerCode(GId) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerCode?Id=" + GId.Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  CodeDuplication(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CodeDuplication",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSupplierByLedgerId(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Supplier_ByLedgerId",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Supplier-----------------//
  //--------------GRN----------------------//
  getGRN(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GRN",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getGRNById(Id_ItemType_LocationId: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GRN_ById",
        Id_ItemType_LocationId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getGRNByDate(BasicFilter_ReportFilter_LocationId: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GET_GRNByDate",
        BasicFilter_ReportFilter_LocationId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getGRNByVoucherNo(VoucherNo_ItemType_LocationId: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GRN_ByVoucherNo",
        VoucherNo_ItemType_LocationId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getGRNByLPO(LPONo_ItemType_LocationId: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GRN_ByLPO",
        LPONo_ItemType_LocationId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveGRN(GRN_Master: any) {
    if (GRN_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_GRN",
          GRN_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_GRN",
          GRN_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  deleteGRN(id: number) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_GRN?Id=" , id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getNextGRNId(LocationId: number) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_Next_GRNId?LocationId=" + LocationId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  updateGrnStatus(u) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_GRNStatus",
        u,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });

  }

  Get_GrnForSearch(Filter:any){
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GrnForSearch",
        Filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------GRN----------------------//

  //--------------LPO----------------------//
  getLPO(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LPO",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getLPOById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LPO_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getLPOFromGRN(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LPO_FromGRN",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getLPOVoucherNo(body: any) {
    //  if (Id != 0) {
    return this.http
      .post(
        this.auth.baseUrl +
        "/services/api/v1/Get_LPOVoucherNo",
        body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
    // }
  }
  getLPOByDate(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LPO_ByDate",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getLPOByVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LPO_ByVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getGRNByLPOVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GRNByLPOVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveLPO(LPO_Master: any) {
    if (LPO_Master.LpoNo == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_LPO",
          LPO_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_LPO",
          LPO_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteLPO(Id: any) {
    if (Id != 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Delete_LPO?Id=" , Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  updateLPOStatus(u) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_LPOStatus",
        u,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });

  }
  //--------------LPO----------------------//
  //--------------Purchase Return----------------------//
  getPurchaseReturn(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseReturn",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPurchaseReturnById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseReturnById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPurchaseReturnByDate(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseReturnByDate",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPurchaseReturnByVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseReturnByVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  savePurchaseReturn(PurchaseReturn_Master: any) {
    if (PurchaseReturn_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_PurchaseReturn",
          PurchaseReturn_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_PurchaseReturn",
          PurchaseReturn_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deletePurchaseReturn(Id: any) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Delete_PurchaseReturn" , Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
  }
  Update_PurchaseReturnStatus(Id: any) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_PurchaseReturnStatus" , Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
  }

  //--------------Purchase Return----------------------//

  //---------------Purchase Analysis---------------------//

  PurchaseAnalysisMaster(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseAnalysisMaster",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  PurchaseAnalysisDetails(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseAnalysisDetails",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //---------------Purchase Analysis---------------------//
  //---------------Mobile PDT---------------------//
  MobilePDTSearch(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PDTGrnSearch",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  LoadPurchasefromMobilePDT(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchasefromMobilePDT",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  MobilePDTSearchPRN(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PDTPRNSearch",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  LoadPurchasefromMobilePDTPRN(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchasefromMobilePDTPRN",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Mobile PDT---------------------//
  //---------------Debit Note Distribution---------------------//
  Get_DebitNoteListForDistribution(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DebitNoteListForDistribution",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_PurchaseBySupplier(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseBySupplier",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_PurchaseDetailsByPurchaseId(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseDetailsByPurchaseId",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_DistributionList(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DistributionList",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_DistributionById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DistributionById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_Distribution(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_Distribution",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_PurchaseForDistribution(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseForDistribution",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_DebitNoteDistribution(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_DebitNoteDistribution",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Debit Note Distribution---------------------//
  //---------------Sales Analysis------------------------------//
  Get_SalesAnalysisMaster(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesAnalysisMaster",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_SalesAnalysisDetails(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesAnalysisDetails",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_SalesAnalysisLayout(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesAnalysisLayout",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Sales Analysis------------------------------//
  //---------------ReverseCharge---------------------------------//

  Save_ReverseCharge(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_ReverseCharge",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_ReverseCharge(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_ReverseCharge",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReverseChargeById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ReverseChargeById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReverseChargeList(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ReverseChargeList",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_ReverseCharge(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_ReverseCharge",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReverseChargeVoucherType(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ReverseChargeVoucherType",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_GenerateReverseChargeVoucheNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GenerateReverseChargeVoucheNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReverseChargeTaxCode() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_ReverseChargeTaxCode",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReverseChargeCountry() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_ReverseChargeCountry",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReverseChargeFCY() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_ReverseChargeFCY",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReverseChargeCurrencyRate(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ReverseChargeCurrencyRate",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReverseChargeAccount(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ReverseChargeAccount",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReverseChargeForPrint(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ReverseChargeForPrint",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------ReverseCharge---------------------------------//

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/inventory/in-purchases.service.ts